module.exports = __webpack_public_path__ + "5fe79d91c9184600a6285987af44d7f5.svg";